module.exports = __webpack_public_path__ + "media/application/images/ui/dropdown-9954261174821fa5715cebc3d0cf86f2.png";